<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h2 class="box-title"><i class="fa fa-cube mr-5"></i>{{'logistics-order-material' | translate($parent.language)}}</h2>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-9 col-xs-12">
            Logistikmaterial von Verpackung-Roper bestellen Sie bitte ab sofort direkt hier im Onlineshop:<br/>
            <strong><a href="http://www.verpackung-roper.de" target="_blank">www.verpackung-roper.de</a></strong> <br/>
            Der Bestellvorgang ist in einer kurzen Anleitung erklärt.
            Bitte beachten Sie die neuen ANWR-Sonderpreise und das erweiterte Sortiment.
          </div>
          <div class="col-md-3 col-xs-12">
            <a class="btn btn-info btn-app pull-right" type="button" href="http://www.schuhe.de/cms/hpb/pdf/2018/532ccb6c75b51da033311636e673f493.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i>Download</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Materials',
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  mounted () {
    this.$nextTick(function () {
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/Materials.vue